import { useParams, Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { useFetch } from "../lib/useData";
import { PageHero, Section, Placeholder } from "../components/public/PublicLayout";

const HERO = "https://images.unsplash.com/photo-1621787084849-ed98731b3071?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600";

export function Deities() {
  const { data: deities } = useFetch("/public/deities");
  return (
    <div>
      <PageHero title="Deities & Sacred Idols" subtitle="The divine presences worshipped at our temple" image={HERO} />
      <Section>
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-5" data-testid="deities-grid">
          {(deities || []).map((d) => (
            <Link to={`/worship/deities/${d.slug}`} key={d.id} className="group bg-white rounded-2xl overflow-hidden border border-amber-200/70 hover:shadow-lg hover:border-orange-400 transition-all" data-testid={`deity-${d.slug}`}>
              <div className="aspect-[4/5] overflow-hidden">
                <img src={d.image} alt={d.name} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
              </div>
              <div className="p-4">
                <h3 className="font-display font-bold text-stone-900 leading-tight">{d.name}</h3>
                <p className="text-xs text-stone-500 mt-1 line-clamp-2">{d.short_description}</p>
              </div>
            </Link>
          ))}
        </div>
      </Section>
    </div>
  );
}

export function DeityDetail() {
  const { slug } = useParams();
  const { data: d, loading } = useFetch(`/public/deities/${slug}`, [slug]);
  if (loading) return <Section>Loading…</Section>;
  if (!d) return <Section>Deity not found.</Section>;
  return (
    <div>
      <Section>
        <Link to="/worship/deities" className="inline-flex items-center gap-1 text-orange-700 font-semibold mb-6" data-testid="deity-back"><ArrowLeft className="w-4 h-4" /> All Deities</Link>
        <div className="grid md:grid-cols-2 gap-10">
          <img src={d.image} alt={d.name} className="rounded-3xl shadow-xl w-full h-[460px] object-cover" />
          <div>
            <h1 className="font-display text-3xl md:text-4xl font-extrabold text-stone-900">{d.name}</h1>
            <p className="text-lg text-stone-600 mt-4">{d.short_description}</p>
            <h3 className="font-display font-bold text-xl text-stone-900 mt-8">Spiritual Significance</h3>
            <p className="text-stone-600 mt-2 leading-relaxed">{d.significance}</p>
            <Link to="/seva" className="inline-block mt-8 bg-orange-600 hover:bg-orange-700 text-white font-bold px-6 py-3 rounded-full transition-colors" data-testid="deity-seva-cta">Offer a Seva</Link>
          </div>
        </div>
      </Section>
    </div>
  );
}
